/*# sourceMappingURL=assign-bed.component-XP4RZSZ6.css.map */
